import { useMemo, useState, useEffect } from 'react'

export function usePagination<T>(items: T[], initialRowsPerPage = 25) {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage)

  const pagedItems = useMemo(() => {
    const start = page * rowsPerPage
    return items.slice(start, start + rowsPerPage)
  }, [items, page, rowsPerPage])

  useEffect(() => {
    setPage(0)
  }, [items.length])

  const handlePageChange = (_event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return {
    page,
    setPage,
    rowsPerPage,
    pagedItems,
    totalCount: items.length,
    handlePageChange,
    handleRowsPerPageChange,
  }
}
